import React, { useContext } from "react";
import { Modal } from "antd";
import { ThemeContext } from "../../common/themeContext";


const LogoutModal = ({ show, onYes, onNo }) => {
  const { theme } = useContext(ThemeContext);

  return (
    <Modal
      className={theme === "healthCare" ? "healthcare mx550" : "primecare mx550"}
      open={show}
      onCancel={onNo}
      onOk={onYes}
      footer={[
        <button
          key="cancel"
          className="py3 fw-18 gbo continuebtn savebtn cancelbtn me-20"
          onClick={onNo}
        >
          Cancel
        </button>,
        <button key="yes" className="okbtn continuebtn" onClick={onYes}>
          Yes
        </button>,
      ]}
    >
      <div className="mb-1 heedprodct text-center mt-3">
        Do you want to Logout?
      </div>
    </Modal>
  );
};

export default LogoutModal;
